export default __webpack_public_path__ + "static/media/ruby-logo.6e974c52.png";